import { useState } from "react";
import FAQItem from "../components/FAQItem";
import { FAQS } from "../data/data";
import CTASection from "../components/CTASection";
import { Helmet } from "react-helmet";

export default function ContactPage() {
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <>

<Helmet>
  <title>Contact Us | Millet Momos</title>
  <meta name="description" content="Get in touch with Millet Momos for healthy food orders and inquiries." />
  <link rel="canonical" href="https://milletmomos.com/contact" />
</Helmet>
      <div className="page-banner" style={{ background: "linear-gradient(135deg,#E31E24 0%,#8B0000 100%)" }}>
        <div>
          <h1>Contact <span style={{ color: "var(--yellow)" }}>&amp; Order</span></h1>
          <p>We'd love to hear from you — reach out, follow us, or place an order today!</p>
        </div>
      </div>

      <section className="contact-section">
        <div className="sec-header">
          <h2 className="sec-title">Get In Touch</h2>
          <p className="sec-sub">We're based in Hyderabad and ready to serve you!</p>
        </div>
        <div className="contact-grid">
          {[
            { icon: "📧", title: "Email Us",  body: <><a href="mailto:contact@milletmomos.com">contact@milletmomos.com</a><br /><span style={{ fontSize: ".82rem", color: "#999" }}>We reply within 24 hours</span></> },
            { icon: "📍", title: "Location",  body: <>Hyderabad, Telangana<br />India<br /><span style={{ fontSize: ".82rem", color: "#999" }}>Serving across Hyderabad</span></> },
            { icon: "🕐", title: "Hours",     body: <>Mon - Sat: 9AM - 8PM<br />Sunday: 10AM – 6PM</> },
          ].map((c, i) => (
            <div className="contact-card" key={i}>
              <span className="cc-icon">{c.icon}</span>
              <h3>{c.title}</h3>
              <p>{c.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Order CTA */}
   <CTASection setPage={() => { alert("Ordering is not available yet. Stay tuned for launch!"); }} />
      {/* Social */}
      <section className="social-row">
        <h2>Follow Our Journey</h2>
        <p>Stay updated with new flavours, launch news and behind-the-scenes content.</p>
        <div className="social-btns">
          <a href="#" className="soc-btn soc-ig">📸 Instagram</a>
          <a href="https://www.facebook.com/Milletmomos/" target="_blank" className="soc-btn soc-fb">👍 Facebook</a>
          <a href="#" className="soc-btn soc-tw">🐦 Twitter / X</a>
          <a href="#" className="soc-btn soc-yt">▶ YouTube</a>
        </div>
      </section>

      {/* Full FAQ */}
      <section className="faq-section">
        <div className="faq-wrap">
          <div className="sec-header"><h2 className="sec-title">Frequently Asked Questions</h2></div>
          {FAQS.map((f, i) => (
            <FAQItem
              key={i}
              item={f}
              open={openFaq === i}
              onToggle={() => setOpenFaq(openFaq === i ? null : i)}
            />
          ))}
        </div>
      </section>
    </>
  );
}